define('CustomerCategory.Utils', [
    'Profile.Model',
    'underscore'
], function CustomerCategoryUtils(
    ProfileModelModule,
    _
) {
    'use strict';

    var ProfileModel = ProfileModelModule.ProfileModel || ProfileModelModule;

    var Utils = {
        splitPublishedValues: function splitPublishedValues(value) {
            return _.chain(_.isArray(value) ? value : String(value || '').split(','))
                .map(function trimPublishedValue(entry) {
                    return String(entry || '')
                        .replace(/(?:&amp;|&)(?:nbsp|#160);/gi, '')
                        .replace(/\u00a0/g, '')
                        .replace(/^\s+|\s+$/g, '');
                })
                .filter(function removeEmptyPublishedValue(entry) {
                    return !!entry;
                })
                .value();
        },

        isCategoryVisible: function isCategoryVisible(categoryGroup, customerCategory, currentHost, hasCategoryMap) {
            var groups;
            var domains;

            // The category-group map is optional published metadata. If the whole map is
            // absent, preserve NetSuite's native Commerce Category tree instead of turning
            // every valid category route into a 404. Once any map exists, keep the original
            // fail-closed behavior for individual unmapped categories.
            if (!hasCategoryMap) {
                return true;
            }

            if (String(currentHost || '').toLowerCase() === 'buyflu-sandbox.ethanablatt.com') {
                currentHost = 'buyflushots.nmsincusa.com';
            }

            if (!categoryGroup) {
                return false;
            }

            groups = this.splitPublishedValues(categoryGroup.groups);
            domains = this.splitPublishedValues(categoryGroup.domains);

            return groups.indexOf(String(customerCategory || '1')) >= 0 &&
                (!domains.length || domains.indexOf(String(currentHost || '')) >= 0);
        },

        getShippableAddresses: function getShippableAddresses() {
            var profile = ProfileModel.getInstance();
            var shippableAddressesField;
            var shippableAddresses;
            if (profile && profile.get('customfields')) {
                shippableAddressesField = _.findWhere(profile.get('customfields'), { name: 'custentity_shippable_addresses' });
                shippableAddresses = shippableAddressesField && shippableAddressesField.value;
            }
            return shippableAddresses;
        }
    };

    return Utils;
});
